import * as React from "react";
import classNames from "classnames";
import Spinner from "./Spinner";

interface IProps {
	className?: string;
	children?: {};
}

class Table extends React.Component<IProps> {
	public UNSAFE_componentWillMount() {
		document.body.classList.add("page-loading");
	}

	public componentWillUnmount() {
		document.body.classList.remove("page-loading");
	}

	public render() {
		const props = this.props;

		return (
			<div className={classNames("page-loading-content", props.className)}>
				<Spinner className="page-loading-spinner" />
				{props.children}
			</div>
		);
	}
}

export default Table;
